import gql from 'graphql-tag';

import client from '../graphqlAPI';

// Renames a radio tag and/or moves it between tags and categories.
const POST_EDIT_RADIO_TAG = gql`
  mutation postEditRadioTag($id: Int!, $name: RadioMultilangInput, $isCategory: Boolean) {
    postEditRadioTag(id: $id, name: $name, isCategory: $isCategory) {
      isAuth
      ok
      errors { field message }
      tag { id name { es ca en pt } isCategory usage }
    }
  }
`;

const postEditRadioTag = async ({ id, name, isCategory }) => {
  try {
    const result = await client
      .mutate({
        mutation: POST_EDIT_RADIO_TAG,
        variables: { id, name, isCategory },
        fetchPolicy: 'no-cache',
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const {
      data: { postEditRadioTag: postEditRadioTagData },
    } = result;

    if (postEditRadioTagData) {
      return postEditRadioTagData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: postEditRadioTag = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: postEditRadioTag Error: ${error}`);
    return null;
  }
};

export default postEditRadioTag;
